if (!customElements.get('hotspot-point')) {
  class HotspotPoint extends HTMLElement {
    CARD_WIDTH_DESKTOP = 600;

    selectors = {
      trigger: '[hotspot-point="trigger"]',
      card: '[hotspot-point="card"]'
    }

    constructor() {
      super();
    }

    connectedCallback() {
      this.isOpen = false
      this.elements = {
        triggers: [...this.querySelectorAll(this.selectors.trigger)],
        card: this.querySelector(this.selectors.card)
      }

      if (!this.elements.triggers.length || !this.elements.card) {
        return;
      }

      this.repositionDebounce = debounce((e) => {
        this.reposition(e);
      }, 300);

      this.focusableElements = getFocusableElements(this.elements.card);
      this.hideFocusableElements();
      this.reposition();

      this.elements.triggers.forEach(trigger =>
        trigger.addEventListener('click', this.toggleCard.bind(this))
      );
      window.addEventListener('resize', this.repositionDebounce.bind(this));
      document.addEventListener('click', this.handleDocumentClick.bind(this))
    }

    /**
     * Toggle card visibility.
     * @returns {Void}
     */
    toggleCard() {
      this.isOpen = !this.isOpen;
      this.classList.toggle('is-open');

      this.isOpen && this.getAttribute('overflow') == 'both'
        ? bodyScroll.lock(this.elements.card)
        : bodyScroll.unlock(this.elements.card);

      this.isOpen
      ? this.showFocusableElements()
      : this.hideFocusableElements();
    }

    /**
     * Prevent elements from being tabbable.
     */
    hideFocusableElements() {
      this.focusableElements?.forEach(el => el.setAttribute('tabindex', '-1'));
    }

    /**
     * Make focusable elements targettable.
     */
    showFocusableElements() {
      this.focusableElements?.forEach(el => el.removeAttribute('tabindex'));
    }

    /**
     * Card overflow.
     * @returns {Object} Overflow booleans
     */
    cardOverflow() {
      const rect = this.elements.triggers[0].getBoundingClientRect();

      const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

      const overflow = {
        top: rect.top < 0,
        left: rect.left < this.CARD_WIDTH_DESKTOP,
        bottom: rect.bottom > viewportHeight,
        right: rect.right + this.CARD_WIDTH_DESKTOP > viewportWidth,
      };

      return overflow;
    }

    /**
     * Reposition card.
     */
    reposition() {
      const overflow = this.cardOverflow();

      if (overflow.left && overflow.right) {
        this.setAttribute('overflow', 'both')
      } else if (overflow.right) {
        this.setAttribute('overflow', 'right')
      } else if (overflow.left) {
        this.setAttribute('overflow', 'left')
      } else {
        this.removeAttribute('overflow', 'left')
      }

      this.isOpen && this.getAttribute('overflow') == 'both'
        ? bodyScroll.lock(this.elements.card)
        : bodyScroll.unlock(this.elements.card);
    }

    /**
     * Handle document click.
     * @param {Event} e
     * @returns {Void}
     */
    handleDocumentClick(e) {
      if (
        !this.isOpen
        || e.target == this.elements.triggers[0]
        || e.target.closest('hotspot-point')
      ) {
        return;
      }

      this.toggleCard();
    }
  }

  customElements.define('hotspot-point', HotspotPoint);
}
